export const SPECIALS_CARD_ENDING_SOON_THRESHOLD_DAYS = 7;
export const SPECIALS_CARD_MAX_DISPLAY_DAYS = 14;

export function getSpecialsCardDaysLeft(endStamp?: string | null): number | null {
  if (!endStamp) {
    return null;
  }

  const end = new Date(endStamp).getTime();
  const now = Date.now();
  const diff = Math.ceil((end - now) / (1000 * 60 * 60 * 24));

  return Math.max(0, diff);
}

export function formatSpecialsCardDaysLeft(daysLeft: number): string {
  if (daysLeft > SPECIALS_CARD_MAX_DISPLAY_DAYS) {
    return `${SPECIALS_CARD_MAX_DISPLAY_DAYS}+ days left`;
  }

  return `${daysLeft} ${daysLeft === 1 ? 'day' : 'days'} left`;
}
